import { createSelector } from "reselect"
import { createQueryStringSelector } from "selectors/queryString"
import { COLORS } from "helpers/analyzeConstants"
import { find } from "lodash"

export const CATEGORIES = [{
  id: "dailyForecast",
  label: "Daily Forecast",
  color: COLORS[0],
}]

const getRawFactorCategoryId = createQueryStringSelector("factorCategory", "expectedReturn")

export const getFactorCategoryId = createSelector(
  [getRawFactorCategoryId],
  (displayType) => {
    if (find(CATEGORIES, cat => cat.id === displayType)) {
      return displayType
    }

    return CATEGORIES[0].id
  },
)

export const getFactorCategoryName = createSelector(
  [getFactorCategoryId],
  (displayType) => {
    const category = find(CATEGORIES, cat => cat.id === displayType)
    if (category) {
      return category.label
    }

    return CATEGORIES[0].label
  },
)
